<form class="checkout-payment-options" style="font-size: 18px !important">
    <h2 class="h1 checkout-payment-options__text-primary">
        All available {{ rewardName() }} will be redeemed. Any remaining balance can be paid with a credit card.
    </h2>

    <div class="checkout-payment-options__order">
        <div class="checkout-payment-options__order-row">
            <p class="body-0 checkout-payment-options__text-primary">Order total:</p>
            <div class="checkout-payment-options__order-row-points">
                <!-- Order total in Shopping Dollars; US dollars are shown only for the card amount below. -->
                <span class="primary-cta checkout-payment-options__text-primary"
                    >{{ cartTotalUsd() | appDigitsGrouping }} {{ rewardName() }}</span
                >
            </div>
            <mat-icon
                #tooltip1="matTooltip"
                aria-label="Info"
                matTooltip="Items in this order will appear on your card statement under the retailer's name."
                matTooltipTouchGestures="on"
                role="button"
                svgIcon="ico_info"
                tabindex="0"
                [attr.aria-hidden]="false"
                (click)="tooltip1.toggle()"
            />
        </div>

        @if (hasPointsApplied()) {
            <div class="checkout-payment-options__order-row">
                <p class="body-0 checkout-payment-options__text-primary">{{ rewardName() }} available:</p>
                <span class="checkout-payment-options__order--points primary-cta"
                    >{{ pointsAvailable() | number }} {{ rewardName() }}</span
                >
            </div>

            <!-- All available points are applied automatically; the card pays only the rest. -->
            <div class="checkout-payment-options__order-row">
                <p class="body-0 checkout-payment-options__text-primary">{{ rewardName() }} applied:</p>
                <span class="primary-cta checkout-payment-options__text-primary"
                    >{{ appliedPoints() | number }} {{ rewardName() }}</span
                >
            </div>

            @if (!isPaidFullyWithPoints()) {
                <div class="checkout-payment-options__order-row">
                    <p class="body-0 checkout-payment-options__text-primary">Card:</p>
                    <span class="primary-cta checkout-payment-options__text-primary">{{
                        willBeBilledFromCardUsd() | currency
                    }}</span>
                </div>
            }
        }
    </div>

    <!--
        "Balance due" is hidden for now: per the API, US dollars are shown only when there is a card payment,
        and the value should be the difference left to pay. To restore, render inside
        `@if (isDisplayCreditCartSection())` and re-add PositiveOrZeroPipe to the component imports:

        <div class="checkout-payment-options__order-row">
            <p class="body-0 checkout-payment-options__text-primary">Balance due:</p>
            <p class="subheading-1 checkout-payment-options__text-primary">
                {{ balanceDue() | appPositiveOrZero | currency }}
            </p>
        </div>
    -->

    @if (isDisplayCreditCartSection()) {
        <mat-divider class="checkout-payment-options__order-line"></mat-divider>

        <div class="checkout-payment-options__payment-info">
            <h2 class="h1 checkout-payment-options__text-primary">Payment information</h2>

            <span class="body-1 checkout-payment-options__text-muted">
                {{ willBeBilledFromCardUsd() | currency }}
                will be billed to your card.
            </span>
        </div>

        <div class="billing-section">
            <h3 class="subheading-1 checkout-payment-options__text-primary">Billing address</h3>
            <mat-checkbox
                [checked]="isBillingSameAsShipping()"
                [disabled]="authorizedPayment()"
                (change)="onBillingSameAsShippingChange($event.checked)"
            >
                <span class="body-1 checkout-payment-options__text-primary">Same as shipping address</span>
            </mat-checkbox>
            @if (!isBillingSameAsShipping()) {
                <lib-address-form class="billing-address-form" idPrefix="billing" [form]="billingForm" />
            }
        </div>

        @if (wrongCardUsedErrorMsg()) {
            <mat-error class="card-error" aria-live="assertive" role="alert">
                <mat-icon svgIcon="ico_alert" />
                {{ wrongCardUsedErrorMsg() }}
            </mat-error>
        }

        <app-checkout-payment-options-form
            [isSubmitTouched]="isSubmitTouched()"
            (cardType)="onCardTypeChange($event)"
            (onNameChange)="onNameChange($event)"
        />
    }

    <div class="checkout-payment-options__submit">
        <button mat-raised-button type="button" [disabled]="loading()" (click)="onSubmit()">
            @if (loading()) {
                <mat-spinner class="spinner-loader" diameter="20"></mat-spinner>
            }
            Continue to order review
        </button>
    </div>
</form>
